var map = {
	"./gold_symbol_0.png": "8af9",
	"./gold_symbol_1.png": "9b8a",
	"./gold_symbol_2.png": "c4fa",
	"./gold_symbol_3.png": "6d29",
	"./gold_symbol_4.png": "8a6b",
	"./gold_symbol_5.png": "422c",
	"./gold_symbol_6.png": "80ad",
	"./gold_symbol_7.png": "8211",
	"./gold_symbol_8.png": "2c76"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "afba";